import React from 'react'
import { useLocation } from 'react-router-dom'

export const IframeView = () => {

  // let {search} = useLocation();
  // let query = new URLSearchParams(search);

  // // Se debe hacer el get con el nombre del parametro de la url
  // let urlParam = query.get("token");
  // let urlParamIdServ = query.get("idServicio");
  // let urlParamIdPort = query.get("idPortal");

  // let url = 'https://misaldotest.tecmilenio.mx:3001/api/Saldos/recepcionToken';

  // // console.log(urlParam, urlParamIdServ, urlParamIdPort)

  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");
  
  // var raw = JSON.stringify({  
  //   "token": urlParam,
  //   "idPortal": urlParamIdPort,
  //   "idServicio": urlParamIdServ
  // });
  
  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };
  
  // fetch("https://misaldotest.tecmilenio.mx:3001/api/Saldos/recepcionToken", requestOptions)
  //   .then(response => response.text())
  //   .then(result => console.log(result))
  //   .catch(error => console.log('error', error));

  return (
    <div className='App'>
      <iframe id="MiSaldoIframe"
          title="MiSaldoIframe"
          width="550"
          height="630"
          src="/MiSaldoCard">
      </iframe>
    </div>
  )
}
